import dd from "./modules/dd";

export default { dd };
